import { Record } from 'immutable';
import { PartyType } from './party-type';

const VendorPaymentSummaryRecord = Record({
  prepaymentId: 0,
  prepayStatus: null,
  prepaymentCreatedDate: null,
  prepaymentModifiedDate: null,
  prepaymentAmount: null,

  paymentId: 0,
  payStatus: null,
  paymentCreatedDate: null,
  paymentModifiedDate: null,
  paymentAmount: null,

  taxAmount: null,

  adjustmentAmount: null,
  dueAmount: null,
  currency: null
});

export class VendorPaymentSummary extends VendorPaymentSummaryRecord {
  prepaymentId: number;
  prepayStatus: string;
  prepaymentCreatedDate: string;
  prepaymentModifiedDate: string;
  prepaymentAmount: string;

  paymentId: number;
  payStatus: string;
  paymentCreatedDate: string;
  paymentModifiedDate: string;
  paymentAmount: string;

  taxAmount: string;

  adjustmentAmount: string;
  dueAmount: string;
  currency: string;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/vendor-payment-summary.ts